import _set from 'lodash/set';

// types
import { Widget } from '@sprinklr/stories/widget/Widget';
import { AnalyticsProjection } from '@sprinklr/stories/analytics/AnalyticsRequest';
import { NumberFormat } from '@sprinklr/display-builder/widgets/DataTableWidget/types';

// utils
import { getMetricDesignOptionsKey } from './getMetricDesignOptionsKey';

export function getMetricOptionsMap(widget: Widget): (metric: AnalyticsProjection) => NumberFormat {
    const options = widget.options?.metricDesignOptions;
    const { usePretty: fallbackPretty, decimals: fallbackDecimals } =
        widget.options?.base?.numberFormat || {};
    return function(metric: AnalyticsProjection): NumberFormat {
        return {
            usePretty:
                options?.[
                    getMetricDesignOptionsKey(metric.measurementName, metric.aggregateFunction)
                ]?.numberFormat?.usePretty ?? fallbackPretty,
            decimals:
                options?.[
                    getMetricDesignOptionsKey(metric.measurementName, metric.aggregateFunction)
                ]?.numberFormat?.decimals ?? fallbackDecimals,
        };
    };
}
